import api from './api';

/**
 * Shape of the consolidated session bootstrap payload.
 *
 * @typedef {Object} BootstrapData
 * @property {Object} user - Authenticated user (UserBasicSerializer shape).
 * @property {Object|null} merchant - Active merchant detail, or null.
 * @property {Array<Object>} merchants - The user's active merchants with roles.
 * @property {Object|null} subscription - Subscription status, or null.
 */

let bootstrapPromise = null;

/**
 * Load the consolidated session bootstrap (user + merchant + merchants +
 * subscription) in a single request. The in-flight promise is memoized so the
 * auth, merchant, and subscription contexts share one network round-trip on
 * cold load instead of chaining three separate requests.
 *
 * @returns {Promise<BootstrapData>}
 */
export const loadBootstrap = () => {
  if (!bootstrapPromise) {
    bootstrapPromise = api
      .get('/users/auth/bootstrap/')
      .then((response) => response.data)
      .catch((error) => {
        // Don't cache failures so the next consumer can retry.
        bootstrapPromise = null;
        throw error;
      });
  }
  return bootstrapPromise;
};

/**
 * Clear the cached bootstrap so the next loadBootstrap() refetches. Call this
 * whenever the session changes (login, logout, merchant switch).
 *
 * @returns {void}
 */
export const resetBootstrap = () => {
  bootstrapPromise = null;
};

const bootstrapService = { loadBootstrap, resetBootstrap };

export default bootstrapService;
